var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5929C0 14.2146 0.964688 15.1667 2.60798 15.1667H10.412C12.0353 15.1667 13 14.2146 13 12.5929V5.83687C13 4.21515 12.0353 3.26313 10.392 3.26313H9.94626C9.93296 1.39848 8.40942 0 6.5 0C4.59058 0 3.06704 1.39848 3.05374 3.26313H2.60798C0.964688 3.26313 0 4.21515 0 5.83687V12.5929ZM5.1827 3.26313C5.19601 2.42273 5.70829 1.81869 6.5 1.81869C7.29171 1.81869 7.80399 2.42273 7.8173 3.26313H5.1827ZM2.36182 12.2318V6.19798C2.36182 5.75808 2.56141 5.59394 2.96725 5.59394H10.0328C10.4386 5.59394 10.6382 5.75808 10.6382 6.19798V12.2318C10.6382 12.6652 10.4386 12.8359 10.0527 12.8359H2.96725C2.56141 12.8359 2.36182 12.6652 2.36182 12.2318Z",
    fill: "#21FFEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.0a2c2d67d38f68228e0cab9743d9705c.svg";
export { ForwardRef as ReactComponent };